import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLightningBolt = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23.5 21H27c.406 0 .781.281.906.656.157.407.063.844-.25 1.125l-8 7c-.375.282-.875.313-1.25.032a.97.97 0 0 1-.343-1.188L20.468 23h-3.5c-.407 0-.782-.25-.907-.625-.156-.406-.062-.844.25-1.125l8-7c.375-.281.875-.313 1.25-.031a.97.97 0 0 1 .344 1.187L23.5 21Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgLightningBolt;
